import { render, staticRenderFns } from "./GItemTop.vue?vue&type=template&id=65635e86&scoped=true&"
import script from "./GItemTop.vue?vue&type=script&lang=ts&"
export * from "./GItemTop.vue?vue&type=script&lang=ts&"
import style0 from "./GItemTop.vue?vue&type=style&index=0&id=65635e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65635e86",
  null
  
)

export default component.exports